export const campanhas = {
  titulo: 'Campanhas',
  nova: 'Nova campanha',
  colunas: {
    nome: 'Nome',
    periodo: 'Período',
    fase: 'Fase',
    progresso: 'Progresso',
    acoes: 'Ações',
  },
  /** Selo da campanha ativa na lista (spec 29 R14). */
  ativaSelo: 'Ativa',
  estados: { aberta: 'Aberta', agendada: 'Agendada', encerrada: 'Encerrada', inativa: 'Inativa' },
  form: {
    nome: 'Nome',
    inicio: 'Início',
    fim: 'Fim',
    janela: 'Janela prevista de envio',
    entregaPrevista: 'Estimativa de recebimento do brinde',
    entregaPrevistaHint:
      'Informe uma estimativa das datas entre as quais o profissional vai receber o brinde. Aparece para a pessoa no formulário.',
    entregaInicio: 'De',
    entregaFim: 'Até',
    dataInvalida: 'Data inválida.',
    calendario: 'Escolher {{campo}} no calendário',
  },
  acoes: {
    abrir: 'Abrir',
    ver: 'Ver',
    editar: 'Editar',
    carregarAxiis: 'Carregar do Axiis',
    carregarDeNovo: 'Carregar de novo',
    revisarTexto: 'Revisar texto',
    editarTexto: 'Texto do convite',
    abrirCampanha: 'Abrir campanha',
    desativarEAbrir: 'Desativar {{outra}} e abrir esta',
    enviarConvites: 'Enviar convites',
    enviarNaoRecebidos_one: 'Enviar a 1 pessoa que não recebeu',
    enviarNaoRecebidos_other: 'Enviar aos {{count}} que não receberam',
    lembrar_one: 'Lembrar quem não respondeu',
    lembrar_other: 'Lembrar os {{count}} que não responderam',
    baixarPlanilha: 'Baixar planilha de envio',
    pausar: 'Pausar',
    reabrir: 'Reabrir',
    fechar: 'Fechar campanha',
    editarDatas: 'Editar datas',
  },
  confirmar: {
    desativar: 'Pausar {{nome}}? O formulário deixa de aceitar respostas. Nada é apagado.',
    fechar: 'Fechar {{nome}}? A campanha sai do ar e libera a abertura de outra.',
  },
  checklist: {
    rotulo: 'Preparação da campanha',
    concluido: 'Concluído',
    pendente: 'Pendente',
    participantes: 'Participantes',
    ninguem: 'Ninguém na campanha ainda',
    texto: 'Texto do convite',
    naoRevisado: 'Ainda não revisado',
    editarTexto: 'Editar texto',
    periodo: 'Período',
    terminou: 'O período terminou',
    abrirTitulo: 'Abrir a campanha',
    falta: 'Para abrir, falta: {{itens}}.',
    faltaParticipantes: 'carregar os participantes',
    faltaTexto: 'revisar o texto do convite',
    faltaPeriodo: 'acertar o período',
  },
  acompanhamento: 'Acompanhamento',
  participantes: 'Participantes',
  convite: { titulo: 'Texto do convite', concluirRevisao: 'Concluir revisão' },
  descricao: 'De {{inicio}} a {{fim}}',
  descricaoComEntrega: 'De {{inicio}} a {{fim}} · recebimento do brinde: {{entrega}}',
  fases: {
    preparacao: 'Em preparação',
    vencida: 'Vencida',
    agendada: 'Agendada',
    aberta: 'Aberta',
    encerrada: 'Encerrada',
    pausada: 'Pausada',
    fechada: 'Fechada',
  },
  resumoAbrir_one: '{{count}} pessoa · {{idiomas}} · de {{inicio}} a {{fim}}',
  resumoAbrir_other: '{{count}} pessoas · {{idiomas}} · de {{inicio}} a {{fim}}',
  abrir: {
    pessoas_one: '{{count}} pessoa · {{idiomas}}',
    pessoas_other: '{{count}} pessoas · {{idiomas}}',
    personalizado: 'personalizado',
    padrao: 'padrão',
    oQueAcontece:
      'Ao abrir, o link passa a aceitar respostas. Nenhum e-mail sai sozinho: os convites você envia em Acompanhamento.',
    oQueAconteceAgendada:
      'Ao abrir, o link passa a aceitar respostas a partir de {{inicio}}. Nenhum e-mail sai sozinho: os convites você envia em Acompanhamento.',
  },
  vazio: 'Nenhuma campanha criada.',
  dialogo: { abrir: 'Abrir {{nome}}', outraAtiva: 'Agora está aberta: {{outra}}.' },
  funil: {
    naCampanha: 'Na campanha',
    convidados: 'Convidados',
    acessaram: 'Acessaram',
    responderam: 'Responderam',
    naoConvidados_one: '{{count}} não convidado',
    naoConvidados_other: '{{count}} não convidados',
    falhas: '{{count}} com falha',
    naoAcessaram_one: '{{count}} não acessou',
    naoAcessaram_other: '{{count}} não acessaram',
    pararamNoMeio_one: '{{count}} acessou e não respondeu',
    pararamNoMeio_other: '{{count}} acessaram e não responderam',
    doTotal: '{{p}}% do total',
  },
  filtros: {
    busca: 'Buscar por nome',
    todasFases: 'Todas as fases',
    periodo: 'Período',
    limpar: 'Limpar tudo',
  },
  semResultado: 'Nenhuma campanha com esses filtros.',
} as const;
